module.exports = __webpack_public_path__ + "img/DE00688.7536b77c.png";